/**
 * SNAP-2366 — the Google OAuth callback can hand the browser a short-lived
 * "2FA attempt" JWT at `#/login/social-2fa/:loginToken` instead of a session
 * token. The 2FA endpoints still take a `userId` in the body (the attempt token
 * only becomes the sole identifier once SNAP-2357 flips
 * `ALLOW_LEGACY_2FA_USERID` off), so the page reads the subject back out of the
 * token rather than carrying a second, tamperable `userId` in the URL.
 *
 * This is a decode, NOT a verification — the signature is only ever checked by
 * the API. Anything malformed yields '' so the caller can bail to /login
 * instead of rendering a form bound to nothing.
 */
export function readLoginTokenSubject(loginToken: string): string {
  const parts = (loginToken || '').split('.');
  if (parts.length !== 3 || !parts[1]) return '';

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '==='.slice((base64.length + 3) % 4);
    const binary = atob(padded);
    const json = decodeURIComponent(
      binary
        .split('')
        .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const claims = JSON.parse(json) as { id?: unknown };

    return typeof claims.id === 'string' ? claims.id : '';
  } catch {
    return '';
  }
}
